<script setup>
import { computed } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },

  delay: {
    type: Number,
    required: false,
    default: 0,
  },
});

const styles = computed(() => ({
  'transition-delay': props.visible ? props.delay : 0,
}));
</script>

<template>
  <Transition
    name="overlay-transition"
    :data-delay="delay"
    :style="styles"
  >
    <div
      v-if="visible"
      class="overlay"
    />
  </Transition>
</template>

<style scoped lang="scss">
.overlay {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: color-mix(in srgb, var(--wp-black) 50%, transparent);
}

.overlay-transition-enter-active,
.overlay-transition-leave-active {
  transition: opacity var(--transition-middle);
}

.overlay-transition-enter-from,
.overlay-transition-leave-to {
  opacity: 0;
}

.overlay-transition-leave-to {
  transition-delay: var(--transition-middle);
}

.overlay-transition-enter-to,
.overlay-transition-leave-from {
  opacity: 1;
}
</style>
